import { render, staticRenderFns } from "./NewAddEmployeesPlaning.vue?vue&type=template&id=1870d1fc&scoped=true"
import script from "./NewAddEmployeesPlaning.vue?vue&type=script&lang=js"
export * from "./NewAddEmployeesPlaning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1870d1fc",
  null
  
)

export default component.exports